import { Login, LoginForm } from "react-admin";
import { Box, Typography } from "@mui/material";
import { IS_DEVELOPMENT } from "../config";

export default function LoginPage() {
  return (
    <Login>
      <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
        <img
          src="/logo-green.png"
          alt="TripNester"
          style={{ height: "60px", marginBottom: "16px" }}
        />
        <Typography variant="h5" fontWeight={700} color="primary">
          {IS_DEVELOPMENT ? "Admin Login (Dev)" : "Admin Login"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Sign in to access the admin portal
        </Typography>
      </Box>
      <LoginForm />
    </Login>
  );
}
